import { Container, Paper, Tab, Tabs } from '@mui/material';
import { TabPanel } from 'components';
import useEventSubmission from 'hooks/useAcademyEventSubmission';
import { useEffect, useState } from 'react';
import NewSubmissions from './NewSubmissions';
import CompletedSubmissions from './CompletedSubmissions';

const SubmissionsList = ({ tabValue }) => {
	const [innerTabValue, setInnerTabValue] = useState(0);

	const handleTabChange = (_, newValue) => {
		setInnerTabValue(newValue);
	};

	return (
		<Container maxWidth="lg">
			<Tabs
				value={innerTabValue}
				onChange={handleTabChange}
				aria-label="Submissions Tabs"
			>
				<Tab label="New Submission" />
				<Tab label="Completed Submissions" />
			</Tabs>

			<TabPanel value={innerTabValue} index={0}>
				<NewSubmissions tabValue={innerTabValue} />
			</TabPanel>
			<TabPanel value={innerTabValue} index={1}>
				<CompletedSubmissions tabValue={innerTabValue} />
			</TabPanel>
		</Container>
	);
};

export default SubmissionsList;
